module.exports = __webpack_public_path__ + "static/media/Group 11558.148e449d.svg";